<script>
import BasePage from "../my-components/base-page";
import util from '@/libs/util';
import LgModal from "../my-components/lg-modal";
import expandRow from "@/views/develop/component/exception-expand.vue";
export default {
  name: "page-version",
  components: { BasePage,LgModal},
  data() {
    return {
      table: {
        loading: false,
        data: [],
        page: {
          type:-1,
          current: 1,
          size: 10,
          total: 0,
          sortKey: 'id',
          sortMethod: 'desc',
          keyword:''
        }
      },
      modal:{
        show:false,
        loading:false,
        uploadAddress: util.baseURL + 'dtzj/version/uploadapp',
        version:{
          fileName:"",
          fileSize:0,
          versionNumber:0,
          appVersion:"",
          remark:""
        },
        apkType:1,
      },
      validateVersionNumber:(rule, value, callback) => {
        if (value < 0 ) {
          callback(new Error(this.$t('l.remark244')));
        } else {
          callback();
        }
      },
      validateFileSize:(rule, value, callback) => {
        if (value < 0 ) {
          callback(new Error(this.$t('l.remark245')));
        }  else {
          callback();
        }
      },
    };
  },
  computed: {
    getColumns() {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: this.$t("l.file_name"),
          align: 'center',
          key:'fileName',
          render: (h, params) => {
            return h("a", {
              attrs: {
                href: 'https://static.diantiyun.com/upload/dtzj/version/apk/'+params.row.fileName,
                target:'_blank'
              },
            },params.row.fileName);
          }
        },
        {
          title: this.$t("l.program_version"),
          align: 'center',
          key:"versionNumber",
        },
        {
          title: this.$t("l.version_name"),
          align: 'center',
          key:"appVersion",
        },
        {
          title: this.$t("l.publisher"),
          align: 'center',
          key:"sender",
        },
        {
          title: this.$t("l.file_size")+"(B)",
          align: 'center',
          key:"fileSize",
        },
        {
          title: this.$t("l.publisher_time"),
          align: 'center',
          key:"updateTime",
        },
        {
          title: this.$t("l.note"),
          align: 'center',
          key:"remark",
        },
      ]
    },
    getRules() {
      return {
        'version.fileName': [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
        "version.versionNumber": [{validator: this.validateVersionNumber, trigger: 'blur'}],
        "version.appVersion": [{required: true, message: this.$t('l.remark33'), trigger: 'blur'}],
        "version.fileSize": [{validator: this.validateFileSize,trigger: 'blur'}],
      }
    },
  },
  methods: {
    loadData(page=1) {
      this.table.loading = true;
      this.table.page.current = page;
      let params = this.table.page;
      console.log(this.table.page);
      params.apkType = this.modal.apkType;
      util.ajax.get('/dtzj/version/list',{params}).then((res) => {
        this.table.loading = false;
        this.setPage(res.data);
      });
    },
    setPage(data){
      if(data ){
        console.log(data);
        this.table.data = data.list;
        this.table.page.current = data.pageNumber;
        this.table.page.total = data.totalRow;
      }
    },
    add(){
      this.modal.show = true;
      this.modal.version = {
        fileName:"",
        fileSize:0,
        versionNumber:0,
        appVersion:"",
        remark:""
      };
    },
    deleteData: function () {  // 删除所选数据
      let records = this.$refs.selection.getSelection();
      if(records.length){
        let ids = records.map(re=>re.id).join(",");
        this.$Modal.confirm({
          title: this.$t("l.warn"),
          content: this.$t("l.hint39"),
          onOk: () => {
            util.ajax.get('/dtzj/version/delete',{
              params:{
                ids,
                apkType : this.modal.apkType
              }
            }).then((res) => {
              this.$Message.success(this.$t("l.success"));
              this.loadData();
            });
          },
          onCancel: () => {

          }
        });
      }else{
        this.$Message.error(this.$t("l.remark243"));
      }
    },

    onSubmit(){
      this.$refs.modal.validate((valid) => {
        if (valid) {
          this.modal.loading = true;
          let version = this.modal.version;
          version.apkType = this.modal.apkType;
          // 二次确认 防止出错
          this.$Modal.confirm({
            title:this.$t("l.prompt"),
            content:`
                    <p style="font-weight: bold">请确认无误后，点击提交添加新版本</p>
                    <div><span>APK类型：</span><span>${this.modal.apkType === 1 ? '电梯专家': this.modal.apkType === 2 ?'电梯专家【日本富士】':'电梯专家【越南名龙】'}</span></div>
                                        <div><span>APK名称：</span><span>${this.modal.version.fileName}</span></div>
                                        <div><span>APK版本号：</span><span>${this.modal.version.versionNumber}</span></div>
                                        <div><span>APK大小：</span><span>${this.modal.version.fileSize}</span></div>
                    `,
            okText:this.$t("l.submit"),
            cancelText:this.$t("l.cancel"),
            onOk:()=>{
              util.ajax.post('/dtzj/version/add', version).then(res => {
                this.modal.loading = false;
                if (!res.code) {
                  this.modal.show = false;
                  this.$Message.success(this.$t('l.add_success'))
                  this.loadData();
                }
              }).catch(e => {
                this.modal.loading = false;
              })
            }
          })
        }
        else {
          this.$Message.error(this.$t('l.remark24'));
        }
      })
    },

    handleSuccess(res, file, fileList) {
      console.log(res);
      if (!res.code) {    //    上传成功之后 修改input
        this.modal.version.fileSize = res.size;
        this.modal.version.fileName= file.name;
        this.modal.version.versionNumber= res.versionNumber;
        this.modal.version.appVersion= res.appVersion;
        this.$Message.success(this.$t('l.upload_success'))
      } else {
        this.$Message.error(this.$t('l.upload_fail'))
      }
    },
    handleFormatError(error, file, fileList) {
      this.$Message.error(this.$t('l.remark26'))
      return;
    },

    selectApkType(){
      this.table.page = {
        type:-1,
        current: 1,
        size: 10,
        total: 0,
        sortKey: 'id',
        sortMethod: 'desc',
        keyword:''
      };
      this.loadData(1)
    }

  },
  created() {
    this.loadData();
  },
}
</script>

<template>
  <BasePage :title="$t('l.version_manage')" icon="md-ionitron">
    <Row type="flex" justify="end" class="margin-t-b-10">
      <Col style="display: flex;align-items: center">
        <span>{{$t("l.APK_type")}}:</span>
      </Col>
      <Col class="margin-left-5" style="display: flex;width: 180px">
        <Select :placeholder="$t('l.remark253')"
                @on-change="selectApkType"
                v-model="modal.apkType">
          <Option :value="1">电梯专家</Option>
          <Option :value="2">电梯专家【日本富士】</Option>
          <Option :value="3">电梯专家【越南名龙】</Option>
        </Select>
      </Col>
      <Col  class="margin-left-5">
        <Button type="primary"  @click="add">{{$t('l.add')}} </Button>
      </Col>
      <Col  class="margin-left-5">
        <Button type="error"  @click="deleteData">{{$t('l.delete')}} </Button>
      </Col>
      <Col  class="margin-left-5">
        <Button  @click="loadData(1)">{{$t('l.fresh')}} </Button>
      </Col>
    </Row>
    <Row class="full">
      <Table ref="selection" stripe border :columns="getColumns" :data="table.data" :loading="table.loading"></Table>
      <Row type="flex" justify="center">
        <Col>
          <Page size="small"
                :current="table.page.current"
                :page-size="table.page.size"
                :total="table.page.total"
                show-elevator show-sizer
                show-total
                @on-page-size-change="loadData(1)"
                @on-change="loadData($event)"></Page>
        </Col>
      </Row>
    </Row>

<!--    添加弹框-->

    <lg-modal :width="820" :title="this.$t('l.publisher_new')" :show="modal.show" :loading="modal.loading"
              @on-submit="onSubmit('modal')"
              @on-cancel="modal.loading=false;modal.show = false;">
      <Form label-position="left" :rules="getRules" ref="modal" :model="modal"
            style="max-height: 400px; overflow-y: auto;overflow-x: hidden;">

<!--        上传文件-->
        <Row>
          <Upload
              ref="upload"
              :show-upload-list="true"
              :on-success="handleSuccess"
              :format="['apk']"
              :headers={Authorization:$store.state.user.user.token}
              :on-format-error="handleFormatError"
              :multiple="false"
              :action="modal.uploadAddress"
              style="display: inline-block;width:58px;">
            <Button>{{$t('l.upload_apk')}}</Button>
          </Upload>
        </Row>
        <FormItem :label-width="140"  :label="$t('l.APK_type')">
          <Select :placeholder="$t('l.remark253')"
                  v-model="modal.apkType">
            <Option :value="1">电梯专家</Option>
            <Option :value="2">电梯专家【日本富士】</Option>
            <Option :value="3">电梯专家【越南名龙】</Option>
          </Select>
        </FormItem>

        <!-- 文件名称 -->
        <FormItem :label-width="140" prop="version.fileName" :label="$t('l.file_name')">
          <Input v-model="modal.version.fileName" />
        </FormItem>
<!--       版本号 -->
        <FormItem :label-width="140" prop="version.versionNumber" :label="$t('l.program_version')">
          <InputNumber v-model="modal.version.versionNumber" style="width: 200px" />
        </FormItem>
<!-- 版本名称 -->
        <FormItem :label-width="140" prop="version.appVersion" :label="$t('l.version_name')">
          <Input v-model="modal.version.appVersion" style="width: 200px" />
        </FormItem>
<!--        文件大小-->
        <FormItem :label-width="140" prop="version.fileSize" :label="$t('l.file_size')+'(KB)'">
          <Input v-model="modal.version.fileSize" style="width: 200px"/>
        </FormItem>
<!--        备注-->
        <FormItem :label-width="140" :label="$t('l.note')">
          <Input v-model="modal.version.remark" type="textarea" :rows="4" placeholder="" />
        </FormItem>

      </Form>
    </lg-modal>


  </BasePage>
</template>

<style scoped lang="less">

</style>